import type { FC } from 'react';

import { LinkWithTitle } from '@/components/links';

type TProps = {
  duration: JSX.Element;
  title: string;
  to: string;
  price: string;
  subtitle: JSX.Element;
  displayTitle?: string;
};
export const ServicesButtonsListItem: FC<TProps> = ({
  duration,
  title,
  displayTitle,
  to,
  price,
  subtitle,
}) => {
  return (
    <li>
      <LinkWithTitle title={title} to={to}>
        <span>{duration}</span> {displayTitle ?? title}{' '}
        <span>
          <strong>{price}</strong>
          {subtitle}
        </span>
      </LinkWithTitle>
    </li>
  );
};
